@if(isLayoutWithBanner) {
  <rx-applications-banner/>
}

<div class="container h-100">
  <div
    class="row justify-content-center"
    [ngClass]="{ 'h-100 align-items-center': !isLayoutWithBanner }"
  >
    <div
      [ngClass]="{
        'card-container mx-3 border': isLayoutWithBanner,
        'col-md-6 col-xl-5 p-5 mx-3 border rounded': !isLayoutWithBanner
      }"
    >
      <div class="text-center mb-4">
        <rx-applications-logo />
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>